module.exports = __webpack_public_path__ + "SourceSansPro-ExtraLight.e0761f7c1d612d5ada30.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-ExtraLight.eot
// module id = ../../../../../src/assets/customfonts/SourceSansPro-ExtraLight.eot
// module chunks = styles